import type { ChatVectorIndexOption } from "src/db";
import { ASSET_DATASOURCE_IDS } from "./assetDatasourceIds";
import { matchesUserRole } from "./matchesUserRole";

export type DatasourceKind = "asset" | "document";

const isAsset = (option: ChatVectorIndexOption): boolean =>
    (ASSET_DATASOURCE_IDS as readonly string[]).includes(option.datasource_id);

export const visibleDatasources = ({
    all,
    userRoles,
    kind,
    requireIndex = false,
}: {
    all: ChatVectorIndexOption[];
    userRoles: string[];
    kind: DatasourceKind;
    requireIndex?: boolean;
}): ChatVectorIndexOption[] =>
    all.filter((option) => {
        const hasIndex = requireIndex === false || option.index_id !== "";
        const matchesKind = kind === "asset" ? isAsset(option) : isAsset(option) === false;
        return hasIndex && matchesKind && matchesUserRole({ option, userRoles });
    });
